import { CSSProperties } from 'react'
import { Button, ButtonProps as _ButtonProps } from 'rsuite'

export type ButtonProps = _ButtonProps & {
    visible?: boolean,
    style?: CSSProperties,
}

const buttonStyle = {
    // background: 'var(--rs-btn-primary-bg)',
    // color: 'var(--rs-btn-primary-text)',
    borderRadius: 0,
}

export default ({ children, style, disabled = false, visible = true, ...rest }: ButtonProps) => {
    let _style: any = { ...buttonStyle, ...style }
    if (!visible) {
        _style.visible = 'none'
    }
    return (
        <Button {...rest} style={_style} disabled={disabled}>
            {children}
        </Button>
    )
}
